import { omitBy, isUndefined } from "lodash";

import { PROFILE_TYPES } from "../constants";

export default ({ get, post, put, del, checkStatus, toJSON }) => ({
  createUser: () =>
    post("universe/v1/users", { includeClientToken: true })
      .then((response) => checkStatus(response, { disableRedirects: true }))
      .then(toJSON),
  getUser: () => get("universe/v1/users").then(checkStatus).then(toJSON),
  updateUser: (newUserProperties) =>
    put("universe/v1/users", {
      body: newUserProperties,
    })
      .then(checkStatus)
      .then(toJSON),
  updateUserFlags: ({ importCleverProfiles, ...rest }) =>
    put("universe/v1/users/update_flags", {
      body: {
        cleverClassroomSync: importCleverProfiles,
        ...rest,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  adViewed: (adType) => {
    post("universe/v1/users/view_ad", {
      body: {
        adType,
      },
    }).then(checkStatus);
  },
  getGrades: () =>
    get("universe/v1/users/grades").then(checkStatus).then(toJSON),
  validateEmail: (email) =>
    post("universe/v1/users/validate_email", {
      body: {
        email,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  register: (user) =>
    put("universe/v1/users/register", {
      body: {
        email: user.email,
        password: user.password,
        recaptchaToken: user.recaptchaToken,
        receiveEmails: user.allowMarketingEmails,
        cleverClassroomSync: user.importCleverProfiles,
        classroomsAttributes: user.profileType
          ? [
              {
                classroomType: user.profileType,
                schoolId:
                  user.profileType === PROFILE_TYPES.CLASSROOM
                    ? user.school.id
                    : undefined,
                size:
                  user.profileType === PROFILE_TYPES.CLASSROOM
                    ? user.numberOfKids
                    : undefined,
                name:
                  user.profileType === PROFILE_TYPES.CLASSROOM
                    ? user.className
                    : user.userName,
                gradeId: user.grade.id,
                classroomChampsAttributes: user.selectedChamp
                  ? [
                      {
                        champId: user.selectedChamp?.id,
                        points: user.loggedOutChampPoints,
                      },
                    ]
                  : [],
              },
            ]
          : undefined,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  login: (email, password) =>
    post("universe/v1/authentication/login", {
      body: {
        email,
        password,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  createProfile: ({
    userName,
    profileType,
    grade,
    numberOfKids,
    school,
    className,
    champId,
  }) =>
    post("universe/v1/users/create_profile", {
      body: {
        name: userName || className,
        classroomType: profileType,
        gradeId: grade.id,
        schoolId: school?.id,
        size: numberOfKids,
        classroomChampsAttributes: [{ champId }],
      },
    })
      .then(checkStatus)
      .then(toJSON),
  updateProfile: ({
    userName,
    grade,
    numberOfKids,
    school,
    className,
    profileId,
  }) =>
    put("universe/v1/users/update_profile", {
      body: {
        id: profileId,
        classroomsAttributes: omitBy(
          {
            name: userName || className,
            gradeId: grade?.id,
            schoolId: school?.id,
            size: numberOfKids,
          },
          isUndefined,
        ),
      },
    })
      .then(checkStatus)
      .then(toJSON),
  deleteProfile: (id) =>
    del("universe/v1/users/delete_profile", {
      body: {
        id,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  forgotPassword: (email) =>
    post("universe/v1/passwords/forgot", {
      body: {
        email,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  resetPassword: (password, resetToken) =>
    post("universe/v1/passwords/reset_user", {
      body: {
        password,
        resetToken,
      },
    })
      .then(checkStatus)
      .then(toJSON),
  logout: () =>
    del("universe/v1/authentication/logout").then(checkStatus).then(toJSON),
});
